var map = {
	"./best-actress-3b-lg.jpg": 53,
	"./best-actress-3b-mob.jpg": 54,
	"./best-cinematography-3b-lg.jpg": 55,
	"./best-cinematography-3b-mob.jpg": 56,
	"./best-director-3b-lg.jpg": 57,
	"./best-director-3b-mob.jpg": 58,
	"./best-ensemble-3b-lg.jpg": 59,
	"./best-ensemble-3b-mob.jpg": 60,
	"./best-original-score-3b-lg.jpg": 61,
	"./best-original-score-3b-mob.jpg": 62,
	"./best-original-screenplay-3b-lg.jpg": 63,
	"./best-original-screenplay-3b-mob.jpg": 64,
	"./best-original-supporting-actor-3b-lg.jpg": 65,
	"./best-original-supporting-actor-3b-mob.jpg": 66,
	"./best-picture-3b-lg.jpg": 67,
	"./best-picture-3b-mob.jpg": 68,
	"./best_actor_lg.jpg": 69,
	"./best_actor_mob.jpg": 70,
	"./best_ensemble_lg.jpg": 71,
	"./best_ensemble_mob.jpg": 72,
	"./best_film_editing_lg.jpg": 73,
	"./best_film_editing_mob.jpg": 74,
	"./best_makeup_lg.jpg": 75,
	"./best_makeup_mob.jpg": 76,
	"./best_picture_lg.jpg": 77,
	"./best_picture_mob.jpg": 78,
	"./best_sound_editing_lg.jpg": 79,
	"./best_sound_editing_mob.jpg": 80,
	"./best_sound_mixing_lg.jpg": 81,
	"./best_sound_mixing_mob.jpg": 82,
	"./best_supporting_actor_lg.jpg": 83,
	"./best_supporting_actor_mob.jpg": 84,
	"./best_supporting_actress_lg.jpg": 85,
	"./best_supporting_actress_mob.jpg": 86,
	"./best_visual_effects_lg.jpg": 87,
	"./best_visual_effects_mob.jpg": 88,
	"./fox-3b-header-lg.jpg": 89,
	"./fox-3b-header-mob.jpg": 90
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 248;


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero ^\.\/.*\.jpg$
// module id = 248
// module chunks = 0